import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUploadedProForma } from 'types/db/UploadedProForma';
import { IMappingData } from './useCreateProFormaMapping';

interface IParams {
    organizationUuid: string;
    uploadedProFormaId: number;
    patchData: IMappingData;
}

const updateUploadedProForma = async ({ organizationUuid, uploadedProFormaId, patchData }: IParams): Promise<IUploadedProForma> => {
    const response = await axiosInstance.patch(API_ENDPOINTS.UPLOADED_PRO_FORMAS_BY_ID(organizationUuid, uploadedProFormaId), patchData);
    return response.data;
};

export const useUpdateUploadedProForma = () => useMutation({
    mutationFn: updateUploadedProForma,
});

export default useUpdateUploadedProForma;
